import React, {useState} from 'react';
import {motion} from "framer-motion";

const DevelopmentButton = ({pos, className, children,fadeNone}) => {
    const [popupActiveButton, setPopupActiveButton] = useState(false);
    const popupClassesButton = `popup_development_button ${popupActiveButton ? "activated" : ""}`;
    const fadeUp = fadeNone ? { initial: { opacity: 0, y: 40 }, whileInView: { opacity: 1, y: 0 }, viewport: {once: true, amount: 0.3}, transition: { duration: 0.8, ease:"easeOut"} } : ""

    return (

        <motion.div className={`${className}`} onMouseOver={() => setPopupActiveButton(true)}
                    onMouseLeave={() => setPopupActiveButton(false)} style={{position:"relative"}} {...fadeUp}>
            {children}
            <div className={popupClassesButton} > Redirect temporarily <span>disabled</span> — module <span>under development</span>. </div>
        </motion.div>
    );
};

export default DevelopmentButton;